export default "__VITE_ASSET__CKPNJ8U2__"